import { ApiConnector } from "../../../api/api-connector";
import { fetchSupportedDiagnoses } from "../../../catalogs/supported-diagnoses";
import { DataAdd } from "../../../models/data-add";
import { Patient } from "../patient";

export class AddDiags extends DataAdd {
  constructor(api: ApiConnector, patient: Patient) {
    super(api, patient);
    this.initFields = ["diagnosis_name", "diagnosed_at", "diagnosis_value"];
    this.desc = "Comorbidities for HF study";
    this.bodyField = "diagnoses";
    this.endpoint = "hf/comorbidities";
    this.defaultDateTime = null;
    this.defaultDateTimeName = "Unset (date not required)";
    this.defaultDateTimeFields = ["diagnosed_at"];
    this.reloadToTab = "diags";
  }

  async initEmpty() {
    const supportedDiags = await fetchSupportedDiagnoses();
    const empty = [];
    for (const diag of supportedDiags) {
      const temp = {
        diagnosis_name: diag.data_name,
        diagnosed_at: this.defaultDateTime,
        diagnosis_value: diag.data_value.values_enum[0],
      };
      empty.push(temp);
    }
    this.addingList = empty;
  }

  addItem() {
    this.addingList.push({
      diagnosis_name: null,
      diagnosed_at: this.defaultDateTime,
    });
  }

  async postBulk(): Promise<boolean> {
    this.addingList = this.addingList.filter(
      (diag: any) => diag.diagnosis_value !== "No",
    );
    return await super.postBulk();
  }
}
